<template>
  <div id="maintop">
    <div  v-if="flag">
    <b-input
      id="inline-form-input-name"
      class="mb-2 mr-sm-2 mb-sm-0 title"
      placeholder="请输入社区名" v-model="title"
    ></b-input>

    <br>
    <b-input
      class="mb-2 mr-sm-2 mb-sm-0"
      placeholder="tags  (输入英文标签，以空格分隔)" v-model="tags"
    ></b-input>

    <div class="btn">
      <b-button variant="outline-primary" @click="post">创建</b-button>
    </div>

    </div>
    <!--加载动画-->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

  </div>
</template>

<script>
  import Loading from './Loading'
    export default {
        name: "Post",
      data() {
        return {
          db:{},
          body: '',
          title: '',
          tags: '',
          isLoading: false,
          flag: true
        }
      },

      methods: {
        post(){
            // this.flag = false
            // this.isLoading = true
          let wif = '5JnJpGkHCjU5PZXcjmBwmoFigJybQWNuG1xxLfrebyL7Kqce32y'
          let author = 'starnote'
          let id = 'community'
          let json = ["setRole",{"community":"starnote","account":"lemooljiang","role":"admin"}]

          // this.steem.broadcast.customJson(wif, [], [author], id, JSON.stringify(json), function(err, result) {
          //   console.log(1111, err, result)
          // })

          let json2 = ["updateProps",{"community":"starnote","props":{"title":"starnote / 星空笔记","about":"基于Steem和IPFS的区块链笔记"}}]

          // this.steem.broadcast.customJson(wif, [], [author], id, JSON.stringify(json2), function(err, result) {
          //   console.log(22222, err, result)
          // })

          let wif2 = '5KJN28BSAEChDFRXNZkKg6SDuQGqqRkXMCYjPPHe7zy55yh9BJQ'
          let author2 = 'lemooljiang'
          let json3 = ["subscribe",{"community":"starnote"}]

          this.steem.broadcast.customJson(wif2, [], [author2], id, JSON.stringify(json3), function(err, result) {
            console.log(33333, err, result)
          })





          async function main(){
            await that.saveOneToDb(post, db, tableName)
            //发布到steem上
            await that.postToSteemPro(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)
            //发布到hive上
            that.hive.api.setOptions({ url: 'https://anyx.io' })
            await that.postToHive(wif, parentAuthor, parentPermlinkHive, author, permlink, title, body, jsonMetadata)
            //切换回节点
            that.steem.api.setOptions({ url: 'https://api.steemit.com' })

            let posts = await that.getAllPosts(db)
            that.$store.commit('savePosts', posts.reverse())
            that.$router.push({path: '/blog/'+permlink})
          }
          // main()
          },

        uploadimg(pos, $file){
          this.imgAdd(pos, $file)
        }
      },

      components: {
        Loading
      },

      mounted() {
        let _this = this
        async function main(){
          if(_this.$store.state.username){
            //如果已登录
            if(_this.$store.state.posts == false){
              //第一次打开页面或是刷新
              let db = await _this.initDatabase()
              _this.$store.commit('saveDB',db)
              let posts = await _this.getAllPosts(db)
              _this.$store.commit('savePosts', posts.reverse())
            }
          }

        }
        // main()
      }
    }
</script>

<style scoped>
  #maintop{
    width: 90%;
    height: 100%;
    margin: 0 auto;
  }

  #main{
    height: 40rem;
  }
  .title{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem !important;
    width: 60%;
  }
  .btn{
    margin-top: 0.3rem;
  }
</style>
